export default "__VITE_ASSET__BqdXqIOt__"